@if (!cookiesAccepted) {
  <div class="cookie-warning">
    <p>
      <b>{{'WARNING!' | translate}}</b>
      {{'SITE_USE_COOKIES' | translate}}
    </p>
    <button class="btn btn-warning cookie-agree" (click)="cookiesAgreement()">{{'AGREE' | translate}}</button>
  </div>
}
